export type pathType = 'figureSkating' | 'shorttrack';

export interface Paths {
  about: string;
  clubs: string;
  team: string;
  nationalTeam: string;
  regulations: string;
  rules: string;
  safeguarding: string;
  buyersProfile: string;
  news: string;
  nationalChampionships: string;
  ncRules: string;
  gallery: string;
  contact: string;
  volunteers: string;
}

export const figureSkatingPath = '/figure-skating';
export const shorttrackPath = '/shorttrack';

export const about = 'about';
export const clubs = 'clubs';
export const team = 'team';
export const nationalTeam = 'national-team';
export const regulations = 'regulations';
export const rules = 'rules';
export const safeguarding = 'safeguarding';
export const buyersProfile = 'buyers-profile';
export const news = 'news';
export const nationalChampionships = 'national-championships';
export const ncRules = 'nc-rules';
export const gallery = 'gallery';
export const contact = 'contact';
export const volunteers = 'volunteers';

export const getCompetitionFilePath = (competitionPath: string, competitionFile?: string) => {
  if (competitionFile) {
    competitionPath = `${competitionPath}/${competitionFile}`;
  }
  return competitionPath;
};

export const paths: { [key in pathType]: Paths } = {
  figureSkating: {
    about: `${figureSkatingPath}/${about}`,
    clubs: `${figureSkatingPath}/${clubs}`,
    team: `${figureSkatingPath}/${team}`,
    nationalTeam: `${figureSkatingPath}/${nationalTeam}`,
    regulations: `${figureSkatingPath}/${regulations}`,
    rules: `${figureSkatingPath}/${rules}`,
    safeguarding: `${figureSkatingPath}/${safeguarding}`,
    buyersProfile: `${figureSkatingPath}/${buyersProfile}`,
    news: `${figureSkatingPath}/${news}`,
    nationalChampionships: `${figureSkatingPath}/${nationalChampionships}`,
    ncRules: `${figureSkatingPath}/${nationalChampionships}/${ncRules}`,
    gallery: `${figureSkatingPath}/${gallery}`,
    contact: `${figureSkatingPath}/${contact}`,
    volunteers: `${figureSkatingPath}/${volunteers}`,
  },
  shorttrack: {
    about: `${shorttrackPath}/${about}`,
    clubs: `${shorttrackPath}/${clubs}`,
    team: `${shorttrackPath}/${team}`,
    nationalTeam: `${shorttrackPath}/${nationalTeam}`,
    regulations: `${shorttrackPath}/${regulations}`,
    rules: `${shorttrackPath}/${rules}`,
    safeguarding: `${shorttrackPath}/${safeguarding}`,
    buyersProfile: `${shorttrackPath}/${buyersProfile}`,
    news: `${shorttrackPath}/${news}`,
    nationalChampionships: `${shorttrackPath}/${nationalChampionships}`,
    ncRules: `${shorttrackPath}/${nationalChampionships}/${ncRules}`,
    gallery: `${shorttrackPath}/${gallery}`,
    contact: `${shorttrackPath}/${contact}`,
    volunteers: `${shorttrackPath}/${volunteers}`,
  },
};

export const allPaths = [...Object.values(paths.figureSkating), ...Object.values(paths.shorttrack)] as string[];
